export default {
  game (state, getters, rootState, rootGetters) {
    return state.game
  }
}
